import { PortfolioDto } from "../../../screens/portfolio-info/types/PortfolioDto";
import { createAuthenticatedApiClient, headerValues } from "./AuthenticatedApiClient";

type ApiClient = ReturnType<typeof createAuthenticatedApiClient>;

export function createPortfolioApi(apiClient: ApiClient) {
    const getById = async (id: number): Promise<PortfolioDto | null> => {
        try {
            const response = await apiClient.get<PortfolioDto>(`api/portfolios/${id}`);
            return response?.data ?? null;
        } catch (error: any) {
            console.log(error);
            return null;
        }
    };

    const create = async (portfolio: PortfolioDto): Promise<number | null> => {
        try {
            const response = await apiClient.post<number, PortfolioDto>(
                "api/portfolios",
                portfolio,
                { headers: headerValues.appJson },
            );

            return response?.data ?? null;
        } catch (error: any) {
            console.log(error);
            return null;
        }
    };

    const update = async (portfolio: PortfolioDto): Promise<PortfolioDto | null> => {
        try {
            const response = await apiClient.put<PortfolioDto, PortfolioDto>(
                "api/portfolios",
                portfolio,
                { headers: headerValues.appJson },
            );

            return response?.data ?? null;
        } catch (error: any) {
            console.log(error);
            return null;
        }
    };

    const saveCustomImpliedVolatility = async (
        portfolioId: number,
        body: unknown,
    ): Promise<boolean> => {
        try {
            const response = await apiClient.put(
                `api/portfolios/${portfolioId}/custom-iv`,
                body,
                { headers: headerValues.appJson },
            );

            return response !== null;
        } catch (error: any) {
            console.log(error);
            return false;
        }
    };

    const deleteById = async (id: number, forceDelete: boolean): Promise<boolean> => {
        try {
            const response = await apiClient.delete(
                `api/portfolios/${id}`,
                { params: { forceDelete } },
            );

            return response !== null;
        } catch (error: any) {
            console.log(error);
            return false;
        }
    };

    return {
        getById,
        create,
        update,
        saveCustomImpliedVolatility,
        deleteById,
    };
}
